/**
 * @file Web Gallery upsell modal container.
 */

import compose from 'lodash.flowright';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import WebGalleryUpsellModal from '../components/WebGalleryUpsellModal';
import withModal from '../../../components/global/modal/withModal';
import { WEB_GALLERY_UPSELL_MODAL } from '../../../constants/modals';
import { AccountForWebGalleries } from '../graphql/queries/account';
import { AlbumForWebGalleries } from '../graphql/queries/album';

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

const withUserData = graphql(AccountForWebGalleries, {
  props: ({ data: { me, loading } }) => ({
    user: me,
    loadingUserData: loading,
  }),
  skip: ({ authenticated }) => !authenticated,
});

const withAlbum = graphql(AlbumForWebGalleries, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { loading, album } }) => ({
    loadingAlbum: loading,
    album,
  }),
});

const WebGalleryUpsellModalContainer = compose(
  withRouter,
  connect(mapStateToProps),
  withUserData,
  withAlbum,
)(WebGalleryUpsellModal);

export default withModal(WebGalleryUpsellModalContainer, {
  name: WEB_GALLERY_UPSELL_MODAL,
  hideHeader: true,
  size: 'md',
  type: 'full',
});
